import { render, staticRenderFns } from "./week-achievements-list.vue?vue&type=template&id=71e9e17e&"
import script from "./week-achievements-list.vue?vue&type=script&lang=js&"
export * from "./week-achievements-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports